import { BaseLink, Footer, Header, PageShell, StickyCta } from '@wrenpages/design-system';
import { Outlet, useLocation, useMatches } from 'react-router';
import { brand, contact, footerColumns, mainCta, primaryNav, socialLinks, stickyCta } from '../../config/site';
import { routes } from '../../config/routes';
import { useScrollOnNavigate } from '../../hooks/useScrollOnNavigate';

export interface RouteHandle {
  /** Hide the mobile sticky CTA (pages that already are the conversion). */
  hideStickyCta?: boolean;
  /** Chromeless page (e.g. /links): no header/footer. */
  bare?: boolean;
}

/** Site chrome shared by every page: header (active nav), footer and the mobile sticky CTA. */
export function SiteLayout() {
  const { pathname } = useLocation();
  const handle = (useMatches().at(-1)?.handle ?? {}) as RouteHandle;
  useScrollOnNavigate();

  if (handle.bare) {
    return (
      <PageShell bareMain>
        <Outlet />
      </PageShell>
    );
  }

  return (
    <PageShell
      header={
        <Header
          homeHref={routes.home}
          items={primaryNav.map((item) => ({ ...item, active: pathname.startsWith(item.href) }))}
          cta={mainCta}
          social={socialLinks}
        />
      }
      footer={
        <Footer
          homeHref={routes.home}
          tagline={`${brand.name} — ${brand.tagline}`}
          social={socialLinks}
          columns={footerColumns}
          copyright={brand.copyright}
          legal={
            <>
              {brand.name} · {contact.location} · <BaseLink href={routes.privacy}>Privacy</BaseLink> ·{' '}
              <BaseLink href={routes.terms}>Terms</BaseLink>
            </>
          }
        />
      }
      stickyCta={handle.hideStickyCta ? undefined : <StickyCta {...stickyCta} />}
    >
      <Outlet />
    </PageShell>
  );
}
